interface User {
  firstName: string;
  lastName: string;
  email: string;
  avatar: string;
  userUri: string;
  status: 'ACTIVATE' | 'DEACTIVATE'; // Known statuses ACTIVATE or DEACTIVATE
  disabled?: boolean;
}

export enum ReferencedElementType {
  USER = 'USER',
  ENTITY = 'EXPLORER-ELEMENT',
  SPACE = 'SPACE',
  COMMENT = 'COMMENT'
}

export interface Mentionables {
  id: string;
  value: string;
  denotationChar?: string;
  link?: string;
  target?: string;
  user?: User;
  elementType?: string; // Type label for dropdown of explorer elements
  blotAlternativeIconHtml?: string; // This can be used to show element type icon
  blotTooltip?: string; // Tooltip for hover on mention blot.
  blotClickable?: boolean; // Use pointer cursor and trigger clickable
  blotCustomClasses?: string; // Add classes (space separated) for the blot wrapper, letting more customization
}

export type ElementMentionables = Map<string, Mentionables>;

export interface BareboneMentionable {
  objectSpaceUri: string;
  objectTenantUri: string;
  objectType: ReferencedElementType;
  objectUri: string;
}
